import useTranslation from 'hooks/useTranslation'
import Item from 'containers/Account/Item'
import React, { useState } from 'react'
import { DELETE } from 'rest/request'
import * as urls from 'rest/urls'
import { Device } from '.'

interface DeviceItemProps extends Device {
  setData: React.Dispatch<React.SetStateAction<Device[] | null>>
}

const DeviceItem: React.FC<DeviceItemProps> = ({ id, clientIp, lastAccess, name, clientLocation, isActualDevice, setData }) => {
  const [isLoading, setLoading] = useState(false)
  const { t } = useTranslation('account')

  const removeDevice = async () => {
    if (isLoading || !id) return
    setLoading(true)

    try {
      const response = await DELETE(`${urls.removeDevice}${id}`)
      if (response) {
        setData(prev => prev!.filter((d) => d.id !== id))
        setLoading(false)
      } else {
        throw new Error('Wrong response')
      }

    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <Item
      key={id}
      title={name || ''}
      desc={<>
        {clientIp && <div>IP: {clientIp}</div>}
        {clientLocation && <div>{t('address')}: {clientLocation}</div>}
        {isActualDevice
          ? <div>{t('currentSession')}</div>
          : <div>{`${t('lastAccess')}: ${lastAccess}`}</div>}
      </>}
      action={undefined}
      showArrow={false}
      right={<div
        className='item__icon--right'
        onClick={removeDevice}>
        <i className={`icon icon--${isLoading ? 'loading' : 'trash'}`} />
      </div>}
    />
  )
}

export default DeviceItem